import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const DocumentsModuleStyledContainer = styled(Box)`
  .card {
    display: flex;
    position: relative;
    gap: 20px;
  }

  .documents-content {
    width: 100%;
  }

  .module-title {
    color: #000000;
    font-weight: 500;
    font-size: 16px;
  }

  .documents-list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 15px;
  }

  .document-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .document-item {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #3460b4;
    text-decoration: none;
  }

  .document-button {
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    color: #707070;
    cursor: pointer;
	display: flex;
	align-items: center;
  }
`;

export { DocumentsModuleStyledContainer };
